import { render, staticRenderFns } from "./generalGroup.vue?vue&type=template&id=70ab4c51&"
import script from "./generalGroup.vue?vue&type=script&lang=js&"
export * from "./generalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports